import { CareOrderStatusEnum } from '../types/CareOrder';
import type { ValueOf } from './types';

export const getCareOrderStatusColor = (status: ValueOf<typeof CareOrderStatusEnum>, pendingFix?: boolean) => {
  switch (status) {
    case CareOrderStatusEnum.PendingNew:
    case CareOrderStatusEnum.New:
      return 'var(--colors-orange-lighten)';
    case CareOrderStatusEnum.Working:
    case CareOrderStatusEnum.PartiallyFilled:
    case CareOrderStatusEnum.PendingCancel:
    case CareOrderStatusEnum.PendingReplace:
      return 'var(--colors-blue-lighten)';
    case CareOrderStatusEnum.Rejected:
      return 'var(--colorOrderStatusRejected)';
    case CareOrderStatusEnum.Canceled:
      return 'var(--colorTextDefault)';
    case CareOrderStatusEnum.FailedFill:
      return 'var(--colorTextNegative)';
    case CareOrderStatusEnum.Filled:
    case CareOrderStatusEnum.FilledAndCanceled:
      return pendingFix ? 'var(--colors-blue-lighten)' : 'var(--colorOrderStatusFilled)';
    default:
      // Unexpected, but dont log anything here. CareOrder class already handles this.
      return 'var(--colorTextDefault)';
  }
};
